import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcArrowClockwise = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.0104 6.23225H14.0104M14.0104 6.23225V3.23225M14.0104 6.23225L11.8891 4.11091C11.1199 3.34173 10.1399 2.8179 9.073 2.60568C8.0061 2.39346 6.90023 2.50238 5.89524 2.91867C4.89025 3.33495 4.03126 4.0399 3.42692 4.94437C2.82257 5.84884 2.5 6.91221 2.5 8C2.5 9.0878 2.82257 10.1512 3.42692 11.0556C4.03126 11.9601 4.89025 12.6651 5.89524 13.0813C6.90023 13.4976 8.0061 13.6065 9.073 13.3943C10.1399 13.1821 11.1199 12.6583 11.8891 11.8891",
		stroke: "#fff",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIcArrowClockwise;
